import './FavoriteButton.css';
import { useFavorites } from '../../state/favorites';
import { useSession } from '../../state/session';
import { heart, heart_filled, Icon } from '../Icon/Icon';

type FavoriteButtonProps = {
	id: number;
	size?: number;
};

export const FavoriteButton = ({ id, size }: FavoriteButtonProps): JSX.Element | null => {
	const { isLoggedIn } = useSession();
	const { favorites, addFavorite, removeFavorite, isFavorite } = useFavorites();

	if (!isLoggedIn) return null;
	if (!favorites) return null;
	const liked = isFavorite(id);

	return (
		<button
			className={'favorite-icon ' + (liked ? 'active' : '')}
			onClick={() => (liked ? removeFavorite(id) : addFavorite(id))}
		>
			<Icon shape={liked ? heart_filled : heart} size={size ?? 20} />
		</button>
	);
};
